import { BaseQueryApi, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../features/store';
import { ENV } from '@utils';
import { logout } from '@features/auth/auth.slice';
import { showToast } from '@design-system/components/Toast/showToast';
import { API_CODE_MESSAGE } from '@utils/apiCodeMessage';

interface ApiResponse {
    message?: string;
    code?: string;
    status?: number;
}

interface ApiError {
    status?: number;
    data?: {
        message?: string;
    };
}

const API_BASE_URL = ENV.API_URL;

const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers: Headers, { getState }: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>) => {
        const token = (getState() as RootState).authentication.user?.jwt;

        if (token) {
            headers.set('JWT', token);
        }

        return headers;
    }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const baseQueryWithLogout = async (args: any, api: BaseQueryApi, extraOptions: any) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.data && typeof result.data === 'object' && 'code' in result.data) {
        const apiResponse = result.data as ApiResponse;
        if (apiResponse.code && apiResponse.code in API_CODE_MESSAGE) {
            showToast({
                type: apiResponse.status === 200 ? 'success' : 'error',
                message: API_CODE_MESSAGE[apiResponse.code as keyof typeof API_CODE_MESSAGE]
            });
        }
    }
    if (result.error && typeof result.error === 'object' && 'status' in result.error) {
        console.log(result);
        const apiResponse = result.error as { status: number; data: ApiResponse };
        showToast({
            type: apiResponse.status === 200 ? 'success' : 'error',
            message: API_CODE_MESSAGE[apiResponse.data?.code as keyof typeof API_CODE_MESSAGE] ?? 'Une erreur est survenue'
        });
    } else {
        if (result.error && typeof result.error === 'object' && 'status' in result.error && (result.error as ApiError).status === 403) {
            api.dispatch(logout());
        }
    }

    return result;
};

export const cosemApi = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithLogout,
    endpoints: () => ({})
});
